var map = {
	"./en-au": "4330",
	"./en-au.js": "4330",
	"./en-ca": "7572",
	"./en-ca.js": "7572",
	"./en-gb": "ef37",
	"./en-gb.js": "ef37",
	"./en-ie": "7e7c",
	"./en-ie.js": "7e7c",
	"./en-il": "bad1",
	"./en-il.js": "bad1",
	"./en-in": "6846",
	"./en-in.js": "6846",
	"./en-nz": "8e3f",
	"./en-nz.js": "8e3f",
	"./en-sg": "92a1",
	"./en-sg.js": "92a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b635";